<template>
  <div class="game-vendor-report">
        <form @submit.prevent="() => search()" class="main-form search-form">
            <custom-select
                v-if="isSupervisor"
                :options="webshopOptions"
                :title="$t('VENDOR_REPORT__WEBSHOP')"
                v-model="filter.webshopID"
                @clear="filter.webshopID = ''"
            />
            <custom-input
                :title="$t('VENDOR_REPORT__USERNAME')"
                v-model="filter.username"
                @clear="filter.username = ''"
            />
            <date-picker 
                :title="$t('VENDOR_REPORT__START_DATE')"
                v-model="filter.startDate"
                @clear="filter.startDate = ''"
            />
            <date-picker 
                :title="$t('VENDOR_REPORT__TO_DATE')"
                v-model="filter.toDate"
                @clear="filter.toDate = ''"
            />
            <button class="btn">{{$t('VENDOR_REPORT__SEARCH')}}</button>
        </form>
        <grid 
            v-show="!loading"
            fullGrid
            :title="$t('VENDOR_REPORT__VENDOR_REPORT')"
            :passedData="reportData"
            :passedCount="count"
            :passedPageSize="pageSize"
            :columns="reportColumns"
            @pageChanged="page => search(page)"
        />
        <div class="loader" v-show="loading"></div>
        <custom-snackbar
            :purpose="mainSnackbar.purpose"
            :text="mainSnackbar.text"
            v-if="mainSnackbar.visible"
            @close="mainSnackbar.visible = false"
        />
  </div>
</template>

<script>
import DatePicker from '@/components/ReusableComponents/DatePicker/DatePicker.vue'
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import CustomSelect from '@/components/ReusableComponents/CustomSelect/CustomSelect.vue'
import CustomSnackbar from '@/components/ReusableComponents/CustomSnackbar/CustomSnackbar.vue'
import Grid from '@/components/ReusableComponents/Grid/Grid.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        DatePicker,
        CustomInput,
        Grid,
        CustomSelect,
        CustomSnackbar,
    },
    created() {
        this.search()
        if(!this.isSupervisor) {
            this.setWebshopID()
        }
    },
    data() {
        return {
            filter: {
                username: '',
                startDate: '',
                toDate: '',
                webshopID: '',
            },
            loading: false,
            reportData: [],
            count: 0,
            pageSize: 20,
            reportColumns: [
                {
                    title: this.$t('VENDOR_REPORT__VENDOR_NAME'),
                    key: 'gameVendorName',
                },
                {
                    title: this.$t('VENDOR_REPORT__BET_AMOUNT'),
                    key: 'betAmount',
                    customTemplate: (item, val) => val + ' ' + item.currencycode
                },
                {
                    title: this.$t('VENDOR_REPORT__WIN_AMOUNT'),
                    key: 'winAmount',
                    customTemplate: (item, val) => val + ' ' + item.currencycode   
                },
                {
                    title: this.$t('VENDOR_REPORT__PROFIT'),
                    key: 'profit',
                    customTemplate: (item, val) => val + ' ' + item.currencycode
                },
                {
                    title: this.$t('VENDOR_REPORT__PROFITABILITY'),
                    key: 'profitability',
                    customTemplate: (item, val) => (val * 100) + '%'
                },
                {
                    title: this.$t('VENDOR_REPORT__BET_COUNT'),
                    key: 'betcount',    
                },
                {
                    title: this.$t('VENDOR_REPORT__WIN_COUNT'),
                    key: 'wincount',    
                },
            ],
            mainSnackbar: {
                purpose: 'error',
                text: '',
                visible: false,
            }
        }
    },
    methods: {
        search(page = 1) {
            this.loading = true
            axios
                .get('WebShop/GetShopGameVendorReport', {
                    params: {
                        CurrentPage: page,
                        PageSize: this.pageSize,
                        WebShopId: this.filter.webshopID,
                        UserName: this.filter.username,
                        StartDate: this.filter.startDate,
                        ToDate: this.filter.toDate,
                        OrderColumn: 'profit',
                        OrderDirection: 'desc',
                    }
                })
                .then(resp => {
                    this.loading = false
                    if(resp.data.status != 1) {
                        this.reportData = []
                        this.count = 0
                        this.showError(resp.data.status)
                    }
                    else {
                        this.reportData = resp.data.response
                        this.count = this.reportData.length > 0 ? this.reportData[0].count : 0
                    }
                })
                .catch(() => {
                    this.showError()
                })
        },
        setWebshopID() {
            this.filter.webshopID = this.$store.state.webshops[0].id
        },
        showError(status) {
            this.mainSnackbar.visible = true
            this.mainSnackbar.purpose = 'error'
            this.mainSnackbar.text = 'An Error Occurred While Canceling!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) this.mainSnackbar.text = this.$t('STATUS-CODE__' + code.value)
        },
    },
    computed: {
        isSupervisor() {
            return this.$store.state.shop
        },
        webshopOptions() {
            var options = []
            this.$store.state.webshops.forEach(shop => {
                let title = shop.name
                    ? `${shop.calculatedName} (${shop.name})`
                    : shop.calculatedName
                options.push({ title: title, value: shop.id + '' })
            })
            return options
        },
        statusCodes() {
            return this.$store.state.statusCodes
        },
    },
}
</script>

<style scoped lang="scss">
    .search-form {
        margin-bottom: 0.9375rem;
        max-width: 62.5rem;
        display: flex;
    }
</style>